import { useState } from 'react'
import type { StudioVariantResultDto } from '@lunary/api-client'
import { useSaveExample } from './queries'
import styles from './studio.module.css'

const RATINGS = [1, 2, 3, 4, 5] as const

type Props = {
  readonly label: string
  readonly cardId: string
  readonly variant: StudioVariantResultDto
}

export function VariantResult({ label, cardId, variant }: Props) {
  const [text, setText] = useState(variant.content ?? '')
  const [rating, setRating] = useState(0)
  const [comment, setComment] = useState('')
  const save = useSaveExample()

  const meta = `${variant.model} · ${variant.prompt_version} · ${variant.tokens_in + variant.tokens_out} токенов`

  return (
    <article className={styles.result}>
      <header className={styles.resultHead}>
        <h3>{label}</h3>
        <span className="muted">{meta}</span>
      </header>
      {variant.content === null ? (
        <p className="error-box">{variant.error ?? 'Вариант не сгенерирован'}</p>
      ) : (
        <>
          <details className={styles.original}>
            <summary>Исходный ответ модели</summary>
            <div className="transcript">{variant.content}</div>
          </details>
          <label className="muted" htmlFor={`${label}-text`}>
            Разбор (правьте прямо здесь)
          </label>
          <textarea
            id={`${label}-text`}
            rows={12}
            value={text}
            disabled={save.isSuccess}
            onChange={(e) => setText(e.target.value)}
          />
          <div className={styles.rating} role="radiogroup" aria-label="Оценка ответа модели">
            <span className="muted">Оценка модели</span>
            {RATINGS.map((r) => (
              <button
                key={r}
                role="radio"
                aria-checked={rating === r}
                className={rating === r ? 'active' : 'secondary'}
                disabled={save.isSuccess}
                onClick={() => setRating(r)}
              >
                {r}
              </button>
            ))}
          </div>
          <textarea
            rows={2}
            value={comment}
            disabled={save.isSuccess}
            maxLength={2000}
            placeholder="Комментарий: что хорошо, что поправили"
            aria-label="Комментарий"
            onChange={(e) => setComment(e.target.value)}
          />
          <div className="row" style={{ marginTop: 10 }}>
            <button
              className="ok"
              disabled={save.isPending || save.isSuccess || rating === 0 || text.trim().length < 10}
              onClick={() =>
                save.mutate({
                  card_id: cardId,
                  model_output: variant.content ?? '',
                  expert_output: text,
                  rating,
                  comment,
                  model: variant.model,
                  prompt_version: variant.prompt_version,
                })
              }
            >
              {save.isSuccess ? 'Сохранено' : save.isPending ? 'Сохраняю…' : 'Сохранить как эталон'}
            </button>
            {save.isSuccess && <span className="muted">Эталон одобрен и уже идёт в подсказку модели.</span>}
            {!save.isSuccess && rating === 0 && <span className="muted">Поставьте оценку, чтобы сохранить.</span>}
          </div>
          {save.error && (
            <p className="error-box">{save.error instanceof Error ? save.error.message : 'Не удалось сохранить'}</p>
          )}
        </>
      )}
    </article>
  )
}
